import styled from "styled-components";
import { colors, types } from "../../../libs/themes";

interface MediaCardWrapperProps {
    customHeight?: string;
    customBorderRadius?: string;
}

interface InfoRowProps {
    alignStart?: boolean;
    forceCenter?: boolean;
}

export const MediaPoster = styled.div<{ backgroundImage?: string }>`
    background-image: url(${({ backgroundImage }) => backgroundImage});
    background-size: cover;
    background-position: center;
`;

export const MediaPosterLink = styled.a`
    @media (hover: hover) {
        &:hover {
            cursor: pointer;
            background-color: ${colors.background.halfBlack};
        }
    }
`;

export const MediaPosterArt = styled.div``;

export const MediaPosterImage = styled.img`
    width: 100%;
    height: 720px;
    aspect-ratio: 16 / 9;
    object-fit: cover;
    object-position: 50% 50%;
    border-radius: var(--video-card-border-radius);
    transition: all 0.3s ease-out;

    @media (min-width: 768px) {
        &:not(.is-mobile) {
            border-radius: var(--video-card-border-radius);
        }
    }
`;

export const MediaAncillary = styled.article`
    position: relative;
    @media (min-width: 768px) {
        &:not(.is-mobile) {
            max-height: 0;
            opacity: 0;
            position: absolute;
            top: 100%;
        }
    }
`;

export const MediaMetadata = styled.section``;

export const MediaHighlight = styled.span``;

export const MediaSynopsis = styled.div``;

export const MediaGenre = styled.div``;

export const MediaCrew = styled.div``;

export const MediaRating = styled.div``;

export const MediaCard = styled.article``;
export const MetaContent = styled.div`
    position: absolute;
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
    padding: 16px;
    color: ${colors.text.white};
    z-index: 9999;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    text-align: center;
    justify-content: center;
    cursor: context-menu;
    background: ${colors.background.drakBlue};
    //background:white;
`;

export const TrailerOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    z-index: 2;
    transition: background-color 0.3s ease;
    pointer-events: auto;
    background-color: ${colors.background.transparentBlack};
    transition:
        background-color 0.4s ease,
        backdrop-filter 0.4s ease,
        box-shadow 0.4s ease;

    @media (max-width: 768px) {
        padding: 12px;
        justify-content: flex-start;
        align-items: flex-start;
    }
    //    &:hover ${MetaContent} {
    //   background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.9));
    // }
`;

export const MediaCardWrapper = styled.section<MediaCardWrapperProps>`
    display: flex;
    flex-flow: column nowrap;
    position: relative;
    will-change: transform;
    transition: all 0.3s ease-out;
    box-shadow: ${colors.shadow.cardLight};
    overflow: hidden;
    cursor: pointer;
    border-radius: ${({ customBorderRadius }) => customBorderRadius || `24px`};
    height: ${({ customHeight }) => customHeight || "720px"};

    &:hover ${TrailerOverlay} {
        background-color: ${colors.background.black60};
        backdrop-filter: blur(5px);
        box-shadow: ${colors.shadow.hoverOverlay};
    }

    @media (min-width: 768px) {
        &:not(.is-mobile) {
            height: ${({ customHeight }) => customHeight || "720px"};
            display: block;
        }
    }
`;

export const InfoRow = styled.div<InfoRowProps>`
    display: flex;
    align-items: center;
    justify-content: ${(props) => (props.alignStart ? "flex-start" : "")};
    flex-wrap: nowrap;
    gap: 20px;
    width: 100%;
    overflow: auto;
    overflow: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
`;

export const InfoRowSmall = styled.div.withConfig({
    shouldForwardProp: (prop) => !["forceCenter", "alignStart"].includes(prop),
})<InfoRowProps>`
    display: flex;
    align-items: center;
    justify-content: ${(props) => (props.alignStart ? "" : "center")};
    flex-wrap: nowrap;
    gap: 20px;
    width: 100%;
    overflow: auto;
    overflow: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;

    @media (max-width: 1024px) {
        justify-content: ${(props) =>
            props.forceCenter
                ? "center"
                : props.alignStart
                  ? ""
                  : "flex-start"};
    }
`;

export const InfoItem = styled.div`
    display: flex;
    align-items: center;
    white-space: nowrap;
    svg {
        margin-right: 5px;
    }
    span {
        ${types.headers.small}
        color: ${colors.text.white};
    }
    @media (max-width: 768px) {
        ${types.body.normal}
    }
`;

export const MediaTextWrapperNewInfoItem = styled.div`
    max-width: 460px;
`;

export const MediaTextWrapper = styled.div`
    max-width: 560px;
`;

export const MediaTitle = styled.div`
    ${types.headers.main42}
    color:  ${colors.text.white};
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 900px) {
        font-size: 32px;
        ${types.body.title}
        font-weight: 600;
        text-align: center;
    }
`;

export const MediaDescription = styled.div<{ limitLines?: boolean }>`
    ${(props) =>
        props.limitLines
            ? `
        white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        max-height: 3.2em; /* 2 lines at ~1.6em line-height */
        min-height: 3.2em; /* Ensures short text also takes same space */
      `
            : `
        ${types.body.mediumSubtitle}
        line-height: 24px;
        color: white;
        white-space: normal;
          word-wrap: break-word;
        min-height: 3.2em;

        @media (max-width: 900px) {
          ${types.body.label}
          text-align: center;
        }
      `}
`;

export const GenrePills = styled.div`
    display: flex;
    gap: 10px;

    @media (max-width: 768px) {
        justify-content: center;
        gap: 6px;
    }
`;

export const Genre = styled.div`
    ${types.headers.small}
    padding: 2px 12px;
    border: 1px solid white;
    border-radius: 24px;
    color: ${colors.text.white};
    height: 28px;
    display: flex;
    align-items: center;

    @media screen and (max-width: 1024px) and (min-width: 768px) and (orientation: portrait) {
        ${types.body.normal}
        padding: 2px 8px;
        height: 28px;
    }

    @media (max-width: 900px) {
        ${types.body.normal}
        padding: 2px 10px;
        height: 28px;
    }
`;

export const TrailerButton = styled.button`
    ${types.headers.small}
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: ${colors.background.black};
    color: white;
    border: 1px solid transparent;
    padding: 10px 24px 10px 32px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: ${colors.shadow.frostedWhite};
        cursor: pointer;
    }

    &:focus {
        outline: none;
        border: none;
    }

    svg {
        margin-top: -1px;
    }
`;

export const NewMetaContent = styled.div`
    position: absolute;
    top: 56px;
    left: 47px;
    padding: 16px;
    color: white;
    z-index: 9999;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    cursor: context-menu;
    align-items: flex-start;

    @media (max-width: 900px) {
        top: 24px;
        left: 16px;
        padding: 12px;
        gap: 12px;
    }
`;

export const NewInfoRow = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;

    @media (max-width: 900px) {
        justify-content: center;
        gap: 2px;
        flex-wrap: wrap;
    }
`;

export const Divider = styled.span`
    ${types.headers.itemMedium}
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.text.white};
    font-weight: 500;
    height: 100%;
`;

export const NewInfoItem = styled.div`
    ${types.body.label}
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    @media (max-width: 768px) {
        ${types.body.normal}
    }
`;

export const RedBadge = styled.span`
    ${types.body.normal}
    background-color: ${colors.text.lightGray};
    color: ${colors.text.white};
    padding: 2px 6px;
    border-radius: 4px;
    font-weight: bold;
    @media (max-width: 768px) {
        ${types.body.small}
    }
`;

export const Title = styled.div`
    ${types.headers.main42}
    color: ${colors.text.white};
    margin: 0;
    text-align: left;
    word-wrap: break-word;
    word-break: break-word;

    @media screen and (max-width: 1024px) and (min-width: 768px) and (orientation: portrait) {
        ${types.headers.main30}
    }

    @media (max-width: 900px) {
        ${types.headers.itemMedium}
    }

    @media (max-width: 600px) {
        ${types.body.smallTitle}
        text-align: center;
    }
`;

export const Description = styled.div`
    ${types.body.mediumSubtitle}
    line-height: 24px;
    color: ${colors.text.white};
    margin: 0;
    text-align: left;
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;

    @media (max-width: 900px) {
        ${types.body.label}
    }

    @media (max-width: 600px) {
        ${types.body.normal}
        text-align: center;
    }
`;

export const WatchNowButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: ${colors.background.black};
    color: ${colors.text.white};
    border: 1px solid transparent;
    padding: 10px 24px 10px 32px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s;
    text-align: left;

    &:hover {
        background-color: ${colors.shadow.frostedWhite};
        cursor: pointer;
    }
    @media (max-width: 768px) {
        ${types.body.normal}
        width: 100%;
        justify-content: center;
        padding: 10px 16px;
    }
`;
